import type { ReactNode } from 'react';
import type { Filter, FiltersGroup } from '@/app/common/filters/core/filtersTypes.ts';
import { Column } from '@/app/common/components/Base/List.tsx';
import ShowMoreContainer from '@/app/components/search/components/ShowMoreContainer/ShowMoreContainer.tsx';

type FilterGroupContentProps = {
  filtersGroup: FiltersGroup;
  showMore?: boolean;
  limit?: number;
  children: (filters: Filter[]) => ReactNode;
};

export const FilterGroupContent = ({
  filtersGroup,
  showMore = false,
  limit = 15,
  children,
}: FilterGroupContentProps) =>
  showMore ? (
    <ShowMoreContainer hasLimit={true} filtersGroup={filtersGroup} limit={limit}>
      {(visibleFiltersGroup) => (
        <Column gap={16} columns={1}>
          {children(visibleFiltersGroup.filters)}
        </Column>
      )}
    </ShowMoreContainer>
  ) : (
    <>{children(filtersGroup.filters)}</>
  );
